import { useEffect } from 'react';
import { CourseFormatEnum } from '@/models/Course';
import StudentDashboardStats from '@/models/StudentDashboard';
import { SimplifiedCourseProgress } from '@/models/StudentCourseProgress';

type HookOptions = {
  currentProgress?: SimplifiedCourseProgress;
  otherCoursesStats?: StudentDashboardStats[];
  selectProgress: (id: number) => void;
};

export const useExtraCourseSelection = ({
  currentProgress,
  otherCoursesStats = [],
  selectProgress,
}: HookOptions) => {
  useEffect(() => {
    if (!otherCoursesStats.length) return;

    if (
      !currentProgress?.coursePath.course.formats?.includes(
        CourseFormatEnum.EXTRA_COURSE,
      )
    )
      return;

    const lastProgress = otherCoursesStats.at(-1);

    if (!lastProgress) return;

    selectProgress(lastProgress.id);
  }, [
    currentProgress,
    otherCoursesStats,
    otherCoursesStats.length,
    selectProgress,
  ]);
};
